var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 38,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Update 13-06-2024"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1026 -2544C-1026 -2545.1 -1025.1 -2546 -1024 -2546H24386C24387.1 -2546 24388 -2545.1 24388 -2544V1325C24388 1326.1 24387.1 1327 24386 1327H-1024C-1025.11 1327 -1026 1326.1 -1026 1325V-2544Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1024 -2545H24386V-2547H-1024V-2545ZM24387 -2544V1325H24389V-2544H24387ZM24386 1326H-1024V1328H24386V1326ZM-1025 1325V-2544H-1027V1325H-1025ZM-1024 1326C-1024.55 1326 -1025 1325.55 -1025 1325H-1027C-1027 1326.66 -1025.66 1328 -1024 1328V1326ZM24387 1325C24387 1325.55 24386.6 1326 24386 1326V1328C24387.7 1328 24389 1326.66 24389 1325H24387ZM24386 -2545C24386.6 -2545 24387 -2544.55 24387 -2544H24389C24389 -2545.66 24387.7 -2547 24386 -2547V-2545ZM-1024 -2547C-1025.66 -2547 -1027 -2545.66 -1027 -2544H-1025C-1025 -2544.55 -1024.55 -2545 -1024 -2545V-2547Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015482"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -247,
    y: -74,
    width: 536,
    height: 408,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004741"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -26,
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FFF5F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M14.2417 4.37903C17.2451 -0.79301 24.7536 -0.793012 27.7569 4.37903L40.2326 25.8629C43.236 31.0349 39.4817 37.5 33.4749 37.5H8.52367C2.51689 37.5 -1.23736 31.0349 1.76604 25.8629L14.2417 4.37903Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5668 29.2548C22.2231 29.6444 21.7976 29.8391 21.2903 29.8391C20.7843 29.8405 20.3594 29.6464 20.0156 29.2568C19.6719 28.8672 19.5 28.385 19.5 27.8101C19.5012 27.2366 19.6731 26.755 20.0156 26.3654C20.3582 25.9759 20.7831 25.7811 21.2903 25.7811C21.7964 25.7824 22.2213 25.9772 22.565 26.3654C22.9088 26.7537 23.0806 27.2352 23.0806 27.8101C23.0818 28.3837 22.9106 28.8652 22.5668 29.2548Z",
    fill: "#FFF5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0806 11.3391V19.9327C23.0806 20.9215 22.2791 21.723 21.2903 21.723C20.3016 21.723 19.5 20.9215 19.5 19.9327V11.3391C19.5 10.3504 20.3016 9.54883 21.2903 9.54883C22.2791 9.54883 23.0806 10.3504 23.0806 11.3391Z",
    fill: "#FFF5F6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon2);
export default __webpack_public_path__ + "static/media/Polygon2 .48b8c6c382c4c3d042a0fee0eed5cff2.svg";
export { ForwardRef as ReactComponent };